import { createContext, use } from "react";

/**
 * Context for managing authentication state.
 */
export const AuthContext = createContext(undefined);

/**
 * Retrieves the authentication context.
 *
 * @returns {object} Auth context
 */
export const useAuth = () =>
    use(AuthContext) || {
        token: null,
        logout: () => {},
        isTokenExpired: () => false,
        refreshToken: async () => {},
        isAuthenticated: false,
    };
